<mat-dialog-content>
	<mat-form-field>
		<mat-label>Wyszukaj</mat-label>
		<input matInput (keyup)="applyfilter($event.target.value)" cdkFocusInitial />
	</mat-form-field>
	<mat-radio-group name="selected" [(ngModel)]="selected">
		<mat-radio-button *ngFor="let destination of destinations" [value]="destination.id">
			{{ destination.name }}
		</mat-radio-button>
	</mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-stroked-button mat-dialog-close>Anuluj</button>
	<div class="spacer"></div>
	<button mat-stroked-button (click)="clear()">Wyczyść</button>
	<div class="spacer"></div>
	<button mat-stroked-button [mat-dialog-close]="selected" color="warn">Wybierz</button>
</mat-dialog-actions>
